var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolHtmlLong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_219_4769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00195 27C9.00195 17.0589 17.0608 9 27.002 9H63.002C72.9431 9 81.002 17.0589 81.002 27V63C81.002 72.9411 72.9431 81 63.002 81H27.002C17.0608 81 9.00195 72.9411 9.00195 63V27Z",
    fill: "url(#paint0_linear_219_4769)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3435 58.5041L45.002 63L58.6604 58.5041L60.9005 27H29.1034L31.3435 58.5041ZM55.2327 32.2734L54.9319 36.4922H39.3053L39.6862 41.9063H54.5559L53.6504 54.6048L45.002 57.4948L36.3532 54.6048L36.0577 50.3438H40.2765L40.3619 51.5034L45.002 53.0434L49.6429 51.5036L50.0219 46.125H35.7416L34.7712 32.2734H55.2327Z",
    fill: "url(#paint1_linear_219_4769)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_219_4769",
    x: 0.00195312,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_219_4769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_4769",
    x1: 45.002,
    y1: 9,
    x2: 45.002,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_4769",
    x1: 45.0017,
    y1: 27,
    x2: 45.0017,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolHtmlLong);
export default __webpack_public_path__ + "static/media/symbol-html-long.22d1aebe329aec74f83ae20b0f44b11d.svg";
export { ForwardRef as ReactComponent };